import React from 'react';
import { MainContainer, SelectContainer, Select, ErrorText } from './styles';

const { Option } = Select;

export default ({
    id,
    name,
    style,
    placeholder,
    value,
    onSearch,
    onChange,
    onBlur,
    onClear,
    error,
    data,
    allowClear,
    showSearch,
    disabled
}) => {
    return (
        <MainContainer style={style}>
            <SelectContainer error={error}>
                <label>{placeholder}</label>
                <Select
                    id={id}
                    name={name}
                    showSearch={showSearch}
                    allowClear={allowClear}
                    bordered={false}
                    value={value}
                    onSearch={onSearch}
                    onChange={onChange}
                    onBlur={onBlur}
                    onClear={onClear}
                    filterOption={false}
                    defaultActiveFirstOption={false}
                    notFoundContent={null}
                    disabled={disabled}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                >
                    {data.map(({value, label}) => (<Option key={value} value={value}>{label}</Option>))}
                </Select>
            </SelectContainer>
            {error && <ErrorText>{error}</ErrorText>}
        </MainContainer>
    );
};